// Firebase App (the core Firebase SDK) is always required and must be listed first
import { initializeApp } from 'firebase/app'

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import { getAnalytics } from 'firebase/analytics'

import { User, getAuth } from 'firebase/auth'
import { initializeFirestore } from 'firebase/firestore'
import { isProduction } from '../../config'

const win = window as any

// TODO: Replace the following with your app's Firebase project configuration
// For Firebase JavaScript SDK v7.20.0 and later, `measurementId` is an optional field
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseio.com`,
  projectId: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}`,
  storageBucket: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig)

export default firebaseApp

export const auth = getAuth(firebaseApp)

export const db = initializeFirestore(firebaseApp, {
  // Needed for Firestore support in Cypress (see https://github.com/cypress-io/cypress/issues/6350)
  experimentalForceLongPolling: !!win.Cypress,
})

export async function getFbUser() {
  return new Promise<User | null>((resolve) => {
    const unsubscribe = auth.onIdTokenChanged((user) => {
      resolve(user)
      unsubscribe()
    })
  })
}

if (isProduction) {
  getAnalytics(firebaseApp)
}
